import type { IssueId } from '../../../../model/issue';
import type { PercentPosition } from '../../common/utils/timeline';

type Props = {
	isDone: boolean;
	isSelectEnabled: boolean;
	isHovered: boolean;
	id: IssueId;
	innerRef: (arg1: HTMLDivElement | null) => void;
	getPositionFromDate: (date: Date) => PercentPosition;
	onClick: () => void;
	onMouseEnter: () => void;
	onMouseLeave: () => void;
};

function Bar(_: Props) {
	return null;
}

export default Bar;

export type { Props as APIProps };
